import { z } from 'zod';

export const FormSchema = z.object({
  ma_thu_chi: z.string().min(1, { message: 'Mã thu chi không được để trống' }),
  ten_thu_chi: z.string().min(1, { message: 'Tên thu chi không được để trống' }),
  ghi_chu: z.string().optional().nullable(),
  ma_cha: z.string().optional().nullable(),
  parent_uuid: z.string().optional().nullable(),
  stt: z.number().optional().default(0),
  trang_thai: z.number().min(0, { message: 'Trạng thái không được để trống' }).default(1)
});

export type FormValues = z.infer<typeof FormSchema>;

export const initialFormValues: FormValues = {
  ma_thu_chi: '',
  ten_thu_chi: '',
  ghi_chu: '',
  ma_cha: '',
  stt: 0,
  trang_thai: 1
};
